import { NgModule } from '@angular/core';
import { WINDOW } from '@app/common/app-tokens';
import { WindowService } from '@app/services/window.service';

export function factoryFn(windowService: WindowService) {
  return windowService.nativeWindow;
}

@NgModule({
  providers: [
    WindowService,
    { provide: WINDOW, useFactory: factoryFn, deps: [WindowService] }
  ]
})
export class WindowModule { }
